import { __rest } from 'tslib';
import React__default from 'react';
import { Caption } from '../Typography/index.es.js';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

const MAPPING_COLOR_500 = {
    branding: 'primary500',
    link: 'link500',
    success: 'success500',
    error: 'error500',
    pending: 'pending500',
};
const MAPPING_COLOR_600 = {
    branding: 'primary600',
    link: 'link600',
    success: 'success600',
    error: 'error600',
    pending: 'pending600',
};
const MAPPING_COLOR_50 = {
    branding: 'primary50',
    link: 'link50',
    success: 'success50',
    error: 'error50',
    pending: 'pending50',
};
const Wrapper = styled.span `
  ${CommonStyles}
  display: inline-flex;
  align-items: center;
  padding-left: ${(p) => p.theme.spacing.s4};
  padding-right: ${(p) => p.theme.spacing.s4};
  height: 1rem;
  border-radius: ${(p) => p.theme.borderRadius.s};
  border: ${(p) => p.borderColor
    ? `${p.theme.borderWeight.m} solid ${p.theme.colors[p.borderColor]}`
    : 'unset'};
  background-color: ${(p) => p.theme.colors[p.backgroundColor]};
`;
const Tag = (_a) => {
    var { variant = 'branding', type = 'primary', content, className } = _a, rest = __rest(_a, ["variant", "type", "content", "className"]);
    const getBgColor = () => {
        if (type === 'primary') {
            if (variant === 'default')
                return 'white';
            return MAPPING_COLOR_500[variant];
        }
        if (type === 'secondary') {
            if (variant === 'default')
                return 'background';
            return MAPPING_COLOR_50[variant];
        }
        if (type === 'ghost') {
            return 'white';
        }
    };
    const getBorderColor = () => {
        if (type === 'ghost') {
            if (variant === 'default')
                return 'border';
            return MAPPING_COLOR_600[variant];
        }
    };
    const getColor = () => {
        if (variant === 'default')
            return 'textPrimary';
        if (type === 'primary')
            return 'white';
        return MAPPING_COLOR_600[variant];
    };
    return (React__default.createElement(Wrapper, Object.assign({ backgroundColor: getBgColor(), borderColor: getBorderColor(), className: className }, rest),
        React__default.createElement(Caption, { color: getColor(), level: 3, weight: "medium", line: 1 }, content)));
};

export { Tag };
